import { render } from "./KsefCompaniesList.vue?vue&type=template&id=32e94dde&scoped=true"
import script from "./KsefCompaniesList.vue?vue&type=script&lang=js"
export * from "./KsefCompaniesList.vue?vue&type=script&lang=js"

import "./KsefCompaniesList.vue?vue&type=style&index=0&id=32e94dde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e94dde"]])

export default __exports__